(function AllInclusivePropertiesView($, Adzuki)
{
	"use strict";
	$(document).ready(function documentReady()
	{
		Adzuki.onload('/AllInclusiveProperties/view/', function onload() {
			if ($('#lightgallery-inline').length > 0) {
				Adzuki.Erez.AllInclusiveProperties.ImageGallery();
			}

			if ($('.ai-reviews')) {
				Adzuki.Ajax.get('/AllInclusiveProperties/reviews/' + $('.ai-reviews').data('id'))
				.then(function success(response) {
					$('.ai-reviews').html(response);
				});
			}

			$('img[data-toggle="modal"]').click(function slideToPropertyImage() {
				$('#modal-property').carousel($(this).data('slide-to'));
			});
		});
	});
}(jQuery, window.Adzuki || {}));